module.exports = __webpack_public_path__ + "img/阳光跑.1fc7cd83.png";